import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeftIcon, ListChecksIcon } from 'lucide-react';
import { useLanguage, type Language } from './LanguageContext';
function UsFlag() {
  return <svg viewBox="0 0 24 16" className="w-5 h-3.5 rounded-sm shadow-sm shrink-0" aria-hidden="true" data-id="element-31">
      <rect width="24" height="16" fill="#B22234" data-id="element-32" />
      <rect y="2" width="24" height="1.5" fill="#fff" data-id="element-33" />
      <rect y="5" width="24" height="1.5" fill="#fff" data-id="element-34" />
      <rect y="8" width="24" height="1.5" fill="#fff" data-id="element-35" />
      <rect y="11" width="24" height="1.5" fill="#fff" data-id="element-36" />
      <rect y="14" width="24" height="1.5" fill="#fff" data-id="element-37" />
      <rect width="10" height="8" fill="#3C3B6E" data-id="element-38" />
      <g fill="#fff" data-id="element-39">
        <circle cx="2" cy="2" r="0.6" data-id="element-40" />
        <circle cx="5" cy="2" r="0.6" data-id="element-41" />
        <circle cx="8" cy="2" r="0.6" data-id="element-42" />
        <circle cx="3.5" cy="4" r="0.6" data-id="element-43" />
        <circle cx="6.5" cy="4" r="0.6" data-id="element-44" />
        <circle cx="2" cy="6" r="0.6" data-id="element-45" />
        <circle cx="5" cy="6" r="0.6" data-id="element-46" />
        <circle cx="8" cy="6" r="0.6" data-id="element-47" />
      </g>
    </svg>;
}
function SpainFlag() {
  return <svg viewBox="0 0 24 16" className="w-5 h-3.5 rounded-sm shadow-sm shrink-0" aria-hidden="true" data-id="element-48">
      <rect width="24" height="16" fill="#AA151B" data-id="element-49" />
      <rect y="4" width="24" height="8" fill="#F1BF00" data-id="element-50" />
    </svg>;
}
const LANGS: {
  code: Language;
  label: string;
  Flag: () => JSX.Element;
}[] = [{
  code: 'en',
  label: 'EN',
  Flag: UsFlag
}, {
  code: 'es',
  label: 'ES',
  Flag: SpainFlag
}];
export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <header className="px-4 py-3 flex items-center bg-white z-20 relative shrink-0 border-b border-slate-100 shadow-[0_2px_6px_rgba(15,23,42,0.04)] gap-2" data-id="element-51">
      {/* Left: back + logo */}
      <div className="flex items-center gap-2 shrink-0" data-id="element-52">
        {!isHome && <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors shrink-0" aria-label="Back" data-id="element-53">
            <ChevronLeftIcon size={24} data-id="element-54" />
          </button>}
        <button type="button" onClick={() => {
        window.dispatchEvent(new CustomEvent('mp:go-home'));
        navigate('/');
      }} aria-label="Home" className="rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 shrink-0" data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/vVB4upnCZU3VzY2zx7sDGz/pasted-image.png" alt="Friedman's Home Improvement" className="h-8 w-auto" data-id="element-56" />
        </button>
      </div>

      {/* Language toggle, pushed to the right so it sits next to the list icon */}
      <div className="flex-1 flex justify-end min-w-0" data-id="element-57">
        <div role="group" aria-label="Language / Langue" className="flex items-center bg-slate-100 rounded-full p-1 text-sm font-bold border border-slate-200 shadow-sm shrink-0" data-id="element-58">
          {LANGS.map(({
          code,
          label,
          Flag
        }) => <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={lang === code} className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-full transition-colors ${lang === code ? 'bg-blue-600 text-white shadow-md' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-59">
              <Flag data-id="element-60" />
              {label}
            </button>)}
        </div>
      </div>

      {/* Right: shopping list shortcut */}
      <div className="flex items-center justify-end shrink-0" data-id="element-61">
        <button type="button" onClick={() => navigate('/list')} aria-label={t('header.shoppingList')} title={t('header.shoppingList')} className="p-2 -mr-1 rounded-full text-slate-600 hover:bg-slate-100 hover:text-blue-600 transition-colors shrink-0" data-id="element-62">
          <ListChecksIcon size={24} data-id="element-63" />
        </button>
      </div>
    </header>;
}